import { UnleaveBoardMutation, UnleaveBoardMutationVariables } from './__generated__/UnleaveBoardMutation'

import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'

const MUTATION = gql`
  mutation UnleaveBoardMutation($ptaId: String!) {
    unleaveBoard(input: { personTenantAssociationId: $ptaId }) {
      id
    }
  }
`

export const useUnleaveBoard = () => useMutation<UnleaveBoardMutation, UnleaveBoardMutationVariables>(MUTATION)
